import React from 'react';
import { EcwOrder, EcwOrdersResponse } from '../EcwConstants';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface EcwOrderInfoProps {
    ecwOrderList: EcwOrdersResponse;
    selectedOrderInfo: EcwOrder | null | undefined;
    handleRevertOrder: (orderId: string | number) => void;
}

const EcwOrderInfo: React.FC<EcwOrderInfoProps> = ({ ecwOrderList, selectedOrderInfo, handleRevertOrder }) => {
    if (ecwOrderList && selectedOrderInfo) {
        const isOrderProcessed = selectedOrderInfo.status?.toLowerCase() === 'administered' && selectedOrderInfo.colour?.toLowerCase() === 'green';
        const isSysAdmin = localStorage.getItem("roleName")?.toLowerCase() === "sysadmin";

        return (
            <div className='order-info-wrapper'>
                <div className='order-info-box'>
                    <div>
                        <span>Patient</span>
                        <p><b>{ecwOrderList?.lastName}, {ecwOrderList?.firstName}</b> {ecwOrderList?.gender} ({ecwOrderList?.birthDate})</p>
                    </div>
                    <div>
                        <span>Item</span>
                        <p><b>{selectedOrderInfo?.vaccineName}</b></p>
                    </div>
                    <div>
                        <span>Provider</span>
                        <p>{selectedOrderInfo?.provider?.lastName} {selectedOrderInfo?.provider?.firstName} ({selectedOrderInfo?.provider?.npi})</p>
                    </div>
                    <div>
                        <span>User</span>
                        <p>{selectedOrderInfo?.loggedUser?.lastName} {selectedOrderInfo?.loggedUser?.firstName}</p>
                    </div>
                    <div>
                        <span>Encounter</span>
                        <p>{selectedOrderInfo?.encounterId} ({selectedOrderInfo?.encounterDate})</p>
                    </div>
                    <div>
                        <span>Location</span>
                        <p>{selectedOrderInfo?.facility?.facilityName} ({selectedOrderInfo?.facility?.facilityId})</p>
                    </div>
                    <div>
                        <span>Order</span>
                        <p>{selectedOrderInfo?.immId} ({selectedOrderInfo?.status})</p>
                    </div>
                    <div>
                        <span>CVX</span>
                        <p>{selectedOrderInfo?.cvxCode}</p>
                    </div>
                </div>
                <div className="order-status-box">
                    <span>Processed</span>
                    <i className='status-square' title={selectedOrderInfo?.isSuccess === false ? (selectedOrderInfo?.ecwResponseMessage ?? '') : ''} style={{ backgroundColor: selectedOrderInfo?.colour || 'gray' }}></i>
                    {(isOrderProcessed && isSysAdmin) && (
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-revert-order">Revert Order</Tooltip>}
                            delay={{ show: 250, hide: 400 }}
                        >
                            <i className="bi bi-arrow-counterclockwise revert-order-btn" onClick={() => handleRevertOrder(selectedOrderInfo?.immId || '')} />
                        </OverlayTrigger>
                    )}
                </div>
            </div >
        )
    }

    return null;
}

export default EcwOrderInfo;
